const embeddedCheckoutFor = (alias) => (`<script type="text/javascript" src="${process.env.REACT_APP_ASSET_HOST}/api/wf-embed-btn-floating.js?b=${alias}"></script>`);
export { embeddedCheckoutFor };
